module.exports = __webpack_public_path__ + "img/banner_truck.e2e4b33e.png";